// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'payback', 'payback Fallback'"},"className":"__className_44b1a1","variable":"__variable_44b1a1"};